export default "__VITE_ASSET__16d6d18c__"